export const filterDataByBrand = (data, brand) => {
    return data.filter((d) => {
        if (brand === 'Carrier' && d.codeModel && d.codeModel.includes('50F')) {
            return true
        }
        if (brand === 'Ciat' && d.codeModel && d.codeModel.includes('PJ')) {
            return true
        }
        return brand === 'All'
    })
}

export const hasActiveFilters = (brand, filters = {}) =>
    (brand !== undefined && brand !== 'All') || Object.values(filters).some((value) => String(value ?? '').trim() !== '')
